module.exports = __webpack_public_path__ + "static/media/game-interviewer9.3fa47766.png";